import script from "./abilityExpansion.vue?vue&type=script&setup=true&lang=js"
export * from "./abilityExpansion.vue?vue&type=script&setup=true&lang=js"

import "./abilityExpansion.vue?vue&type=style&index=0&id=40e97670&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40e97670"]])

export default __exports__